import styled from "styled-components";

import { IStyledAttributes } from "@ryde/shared";
import { greyMui, rydeColors } from "@ryde/theme";

export const PanelTopStyled = styled.div.attrs<IStyledAttributes>({
  "data-e2e": "panel-top-styled",
})`
  border-bottom: 1px solid ${greyMui._300};
  background-color: ${rydeColors.white};
  height: 30px;
  padding-inline: 26px 15px;
  padding-top: 20px;
  padding-bottom: 20px;
  display: flex;
  align-items: center;
  width: 100%;

  & > .panelTopRight {
    display: flex;
    align-items: center;
    margin-inline-start: auto;
  }
`;

export const PanelTopSearchMobileLineStyled = styled.div.attrs<IStyledAttributes>(
  {
    "data-e2e": "panel-top-search-mobile-line",
  },
)`
  box-sizing: border-box;
  display: flex;
  align-items: center;
  width: 100%;
  background-color: ${rydeColors.white};
  border-bottom: 1px solid ${greyMui._300};
  padding-inline: 12px 10px;
  min-height: 40px;
  gap: 6px;

  & > .panelTopRight {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-inline-start: auto;
    min-width: 0;
    flex: 1;
  }
`;
